/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import PropTypes from 'prop-types'
import { Label } from 'semantic-ui-react'
import { Link } from 'react-router-dom-v5-compat'
import { useTranslation } from 'react-i18next'
import useFeature from '../Shared/FeatureProvider/useFeature'

const statusColor = {
    OPEN: 'grey',
    CONTESTED: 'orange',
    RECOVERED: 'green',
    PARTIALLY_RECOVERED: 'green',
    REFUNDED: 'red',
}

const DisputeStatusLabel = ({ dispute, orderId }) => {
    const [t] = useTranslation()
    const { isEnabled } = useFeature()

    if (!isEnabled('disputes')) {
        return null
    }

    if (!dispute || !dispute.status) {
        return null
    }

    const color = statusColor[dispute.status] || 'grey'
    const statusText = dispute.status ? t(`dispute.status_values.${dispute.status}`) : '—'

    return (
            <Link to={`/orders/${orderId}/dispute`}>
                <Label color={color} style={{ cursor: 'pointer' }} >
                   {t('dispute.detail_title')}
                   <Label.Detail>{statusText}</Label.Detail>
                </Label>
            </Link>
    )
}

DisputeStatusLabel.propTypes = {
    dispute: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        status: PropTypes.string,
    }),
    orderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    showLink: PropTypes.bool,
}

export default DisputeStatusLabel
